/* eslint-disable no-nested-ternary */

import { delay, http, HttpResponse } from "msw";

import { type SubscriptionQuestionnaireResponseV3 } from "@vega-api/generated/types/subscriptionQuestionnaireResponseV3";

// Added Mock as Contract removed Example

export const getSubmitSubscriptionQuestionnaireForReviewV3ResponseMock =
  (): SubscriptionQuestionnaireResponseV3 => ({
    data: {
      subscription: {
        id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
        status: "IN_PROGRESS",
        documents: [
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            name: "Subscription Document 1",
            fileKey: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            documentType: "TEMPLATE",
          },
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            name: "Subscription Document 1",
          },
        ],
      },
      subscriptionTask: {
        id: "6c6c51f1-eef0-4545-b89a-f87b3c8c61b1",
        status: "IN_PROGRESS",
        name: "Questionnaire Task 1",
        description: "Complete the subscription questionnaire",
        type: "QUESTIONS",
        questionnaireTasks: [
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            type: "QUESTIONS",
            order: 1,
            name: "Authorized Signatories Verification",
            status: "IN_PROGRESS",
            isAsked: true,
            isDisabled: false,
            questions: [
              {
                id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
                order: 1,
                type: "CHOICE",
                text: "What is the state of jurisdiction of the investor?",
                label: "State",
                isAsked: true,
                isRequired: true,
                choices: [
                  { choice: "California", description: "State of California" },
                  { choice: "New York", description: "State of New York" },
                  { choice: "Texas", description: "State of Texas" },
                ],
                answer: "California",
                prefillData: "California",
              },
              {
                id: "22345678-a3bd-4553-ad4c-672bbf7e9fb3",
                order: 2,
                type: "TEXT",
                text: "Please provide additional information about your legal representative.",
                label: "Legal Representative",
                isAsked: true,
                isRequired: true,
                answer: "John Doe, Legal Counsel",
                prefillData: "John Doe, Legal Counsel",
              },
              {
                id: "33456789-a3bd-4553-ad4c-672bbf7e9fb4",
                order: 3,
                type: "PRINCIPAL_NATURAL_PERSONS",
                text: "Principal Natural Person Information",
                label: "Principals",
                isAsked: true,
                isRequired: true,
                answer: undefined,
                prefillData: undefined,
              },
            ],
          },
        ],
      },
      fund: {
        id: "789a1234-e89b-12d3-a456-426614174002",
        name: "Legal entity 1",
        fundType: "EVERGREEN",
      },
    },
    meta: {},
    errors: {},
  });

export const getGetSubscriptionQuestionnaireV3ResponseMock =
  (): SubscriptionQuestionnaireResponseV3 => ({
    data: {
      subscription: {
        id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
        status: "IN_PROGRESS",
        documents: [
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            name: "Subscription Document 1",
            fileKey: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            documentType: "TEMPLATE",
          },
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            name: "Subscription Document 1",
          },
        ],
      },
      subscriptionTask: {
        id: "6c6c51f1-eef0-4545-b89a-f87b3c8c61b1",
        status: "IN_PROGRESS",
        name: "Questionnaire Task 1",
        description: "Complete the subscription questionnaire",
        type: "QUESTIONS",
        questionnaireTasks: [
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            type: "QUESTIONS",
            order: 1,
            name: "Authorized Signatories Verification",
            status: "IN_PROGRESS",
            isAsked: true,
            isDisabled: false,
            questions: [
              {
                id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
                order: 1,
                type: "CHOICE",
                text: "What is the state of jurisdiction of the investor?",
                label: "State",
                isAsked: true,
                isRequired: true,
                choices: [
                  { choice: "California", description: "State of California" },
                  { choice: "New York", description: "State of New York" },
                  { choice: "Texas", description: "State of Texas" },
                ],
                answer: "California",
                prefillData: "California",
              },
              {
                id: "22345678-a3bd-4553-ad4c-672bbf7e9fb3",
                order: 2,
                type: "TEXT",
                text: "Please provide additional information about your legal representative.",
                label: "Legal Representative",
                isAsked: true,
                isRequired: true,
                answer: "John Doe, Legal Counsel",
                prefillData: "John Doe, Legal Counsel",
              },
              {
                id: "33456789-a3bd-4553-ad4c-672bbf7e9fb4",
                order: 3,
                type: "PRINCIPAL_NATURAL_PERSONS",
                text: "Principal Natural Person Information",
                label: "Principals",
                isAsked: true,
                isRequired: true,
                answer: undefined,
                prefillData: undefined,
              },
            ],
          },
        ],
      },
      fund: {
        id: "789a1234-e89b-12d3-a456-426614174002",
        name: "Legal entity 1",
        fundType: "EVERGREEN",
      },
    },
    meta: {},
    errors: {},
  });

export const getUpdateSubscriptionQuestionnaireV3ResponseMock =
  (): SubscriptionQuestionnaireResponseV3 => ({
    data: {
      subscription: {
        id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
        status: "IN_PROGRESS",
        documents: [
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            name: "Subscription Document 1",
            fileKey: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            documentType: "TEMPLATE",
          },
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            name: "Subscription Document 1",
          },
        ],
      },
      subscriptionTask: {
        id: "6c6c51f1-eef0-4545-b89a-f87b3c8c61b1",
        status: "IN_PROGRESS",
        name: "Questionnaire Task 1",
        description: "Complete the subscription questionnaire",
        type: "QUESTIONS",
        questionnaireTasks: [
          {
            id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
            type: "QUESTIONS",
            order: 1,
            name: "Authorized Signatories Verification",
            status: "IN_PROGRESS",
            isAsked: true,
            isDisabled: false,
            questions: [
              {
                id: "01468693-a3bd-4553-ad4c-672bbf7e9fb2",
                order: 1,
                type: "CHOICE",
                text: "What is the state of jurisdiction of the investor?",
                label: "State",
                isAsked: true,
                isRequired: true,
                choices: [
                  { choice: "California", description: "State of California" },
                  { choice: "New York", description: "State of New York" },
                  { choice: "Texas", description: "State of Texas" },
                ],
                answer: "California",
                prefillData: "California",
              },
              {
                id: "22345678-a3bd-4553-ad4c-672bbf7e9fb3",
                order: 2,
                type: "TEXT",
                text: "Please provide additional information about your legal representative.",
                label: "Legal Representative",
                isAsked: true,
                isRequired: true,
                answer: "John Doe, Legal Counsel",
                prefillData: "John Doe, Legal Counsel",
              },
              {
                id: "33456789-a3bd-4553-ad4c-672bbf7e9fb4",
                order: 3,
                type: "PRINCIPAL_NATURAL_PERSONS",
                text: "Principal Natural Person Information",
                label: "Principals",
                isAsked: true,
                isRequired: true,
                answer: undefined,
                prefillData: undefined,
              },
            ],
          },
        ],
      },
      fund: {
        id: "789a1234-e89b-12d3-a456-426614174002",
        name: "Legal entity 1",
        fundType: "REGISTERED",
      },
    },
    meta: {},
    errors: {},
  });

export const getSubmitSubscriptionQuestionnaireForReviewV3MockHandlerExtended =
  (
    overrideResponse?:
      | SubscriptionQuestionnaireResponseV3
      | ((
          info: Parameters<Parameters<typeof http.post>[1]>[0],
        ) =>
          | Promise<SubscriptionQuestionnaireResponseV3>
          | SubscriptionQuestionnaireResponseV3),
  ) =>
    http.post(
      "*/api/subscriptions/v3/subscriptions/:subscriptionId/questionnaire/:questionnaireId/review-submit",
      async (info) => {
        await delay(10);

        return new HttpResponse(
          JSON.stringify(
            overrideResponse !== undefined
              ? typeof overrideResponse === "function"
                ? await overrideResponse(info)
                : overrideResponse
              : getSubmitSubscriptionQuestionnaireForReviewV3ResponseMock(),
          ),
          { status: 200, headers: { "Content-Type": "application/json" } },
        );
      },
    );

export const getGetSubscriptionQuestionnaireV3MockHandlerExtended = (
  overrideResponse?:
    | SubscriptionQuestionnaireResponseV3
    | ((
        info: Parameters<Parameters<typeof http.get>[1]>[0],
      ) =>
        | Promise<SubscriptionQuestionnaireResponseV3>
        | SubscriptionQuestionnaireResponseV3),
) =>
  http.get(
    "*/api/subscriptions/v3/subscriptions/:subscriptionId/questionnaire/:questionnaireId",
    async (info) => {
      await delay(10);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === "function"
              ? await overrideResponse(info)
              : overrideResponse
            : getGetSubscriptionQuestionnaireV3ResponseMock(),
        ),
        { status: 200, headers: { "Content-Type": "application/json" } },
      );
    },
  );

export const getUpdateSubscriptionQuestionnaireV3MockHandlerExtended = (
  overrideResponse?:
    | SubscriptionQuestionnaireResponseV3
    | ((
        info: Parameters<Parameters<typeof http.put>[1]>[0],
      ) =>
        | Promise<SubscriptionQuestionnaireResponseV3>
        | SubscriptionQuestionnaireResponseV3),
) =>
  http.put(
    "*/api/subscriptions/v3/subscriptions/:subscriptionId/questionnaire/:questionnaireId",
    async (info) => {
      await delay(10);

      return new HttpResponse(
        JSON.stringify(
          overrideResponse !== undefined
            ? typeof overrideResponse === "function"
              ? await overrideResponse(info)
              : overrideResponse
            : getUpdateSubscriptionQuestionnaireV3ResponseMock(),
        ),
        { status: 200, headers: { "Content-Type": "application/json" } },
      );
    },
  );
export const getSubscriptionQuestionnaireV3MockExtended = () => [
  getSubmitSubscriptionQuestionnaireForReviewV3MockHandlerExtended(),
  getGetSubscriptionQuestionnaireV3MockHandlerExtended(),
  getUpdateSubscriptionQuestionnaireV3MockHandlerExtended(),
];
